<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item
              :to="{
                name: 'DashboardHome',
              }"
            >
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              輔翼點數紀錄 查詢
            </b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>

    <b-card>
      <div class="row mb-2 align-items-end">
        <div class="col-8 d-flex items-center">
          <h4 class="font-weight-bold">輔翼點數紀錄 查詢</h4>
        </div>
      </div>

      <b-overlay
        :show="isLoading"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
      >
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          label="會員代碼"
        >
          <b-input-group>
            <b-form-input
              class="mb-2 mr-sm-2 mb-sm-0"
              type="text"
              v-model="params.member_code"
              placeholder="請輸入會員代碼"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          label="查詢開始日期時間"
        >
          <AppDateTimePicker
            v-model="params.start_datetime"
            placeholderForDate="選擇日期"
            placeholderForTime="選擇時間"
          />
        </b-form-group>
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          label="查詢結束日期時間"
        >
          <AppDateTimePicker
            v-model="params.end_datetime"
            placeholderForDate="選擇日期"
            placeholderForTime="選擇時間"
          />
        </b-form-group>
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
        >
          <b-button
            variant="info"
            @click="handleSearch"
            :disabled="isLoading"
          >
            查詢
          </b-button>
        </b-form-group>
        <editor
          class="mb-2 mr-sm-2 mb-sm-0"
          v-model="result"
          width="100%"
          height="300px"
          @init="editorInit"
          lang="json"
          theme="chrome"
          :disabled="!editable"
        >
        </editor>
      </b-overlay>
    </b-card>
  </div>
</template>

<style scoped lang="scss">
.group + .group {
  border-top: 1px solid #cdd6dc !important;
}
</style>
<script>
import { mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import * as consts from "@/consts";
import PermissionChecker from "@/utils/PermissionChecker";
import editor from "vue2-ace-editor";
import fileMixin from "@/mixins/uploadFile";
import flapsApi from "@/apis/flaps"
import AppDateTimePicker from '@/components/AppDateTimePicker.vue'
import { required } from "@vuelidate/validators";
import moment from "moment";


export default {
  mixins: [fileMixin],
  components: { editor, AppDateTimePicker },
  validationConfig: {
    $lazy: true,
  },
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return {
      params: {
        member_code: {required},
        start_datetime: {required},
        end_datetime: {required},
      }
    };
  },
  data() {
    const start = moment().subtract(3, 'years').startOf('day');
    const end = moment().endOf('day');

    return {
      code: null,
      result: "",
      color: "",
      isLoading: false,
      isSubmitting: false,
      formGroups: {},
      module: {},
      fetchedVariableId: null,
      canEdit: false,
      params: {
        member_code: null,
        start_datetime: start.format('YYYY-MM-DD HH:mm'),
        end_datetime: end.format('YYYY-MM-DD HH:mm'),
      },
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    orgId() {
      return this.organization.id;
    },
    editable() {
      return !this.isShownByVariableCode || this.canEdit
    },
  },
  mounted() {
    if (!this.checkPermission([consts.HTY_FLAPS_SETTING_QUERY])) {
      this.$swal
        .fire({
          type: "error",
          text: "你沒有權限訪問此頁面",
          confirmButtonColor: "#d33",
        })
        .then(() => {
          this.$router.push({
            name: "OrganizationVariableList",
          });
        });
    }

  },
  methods: {
    editorInit() {
      require("brace/ext/language_tools");
      require("brace/mode/json");
      require("brace/mode/html");
      require("brace/theme/chrome");
    },
    async handleSearch() {
      if (!this.params.member_code) {
        this.$swal.fire({
          type: "warning",
          text: "請輸入會員代碼",
        });
        return;
      }

      try {
        this.isSubmitting = true;
        this.result = "查詢中...";
        const params = {
          ...this.params,
          start_datetime: moment(this.params.start_datetime).startOf('minute').format('YYYY-MM-DD HH:mm:ss'),
          end_datetime: moment(this.params.end_datetime).endOf('minute').format('YYYY-MM-DD HH:mm:ss'),
        };
        
        const result = await flapsApi.queryBonusLog(params);
        this.result = JSON.stringify(result.data, null, 2);
      } catch (error) {
        this.result = JSON.stringify(error.response?.data || error.message, null, 2);
      }
      this.isSubmitting = false;
    },
    checkPermission(permissions) {
      const checker = new PermissionChecker();
      return checker.check(permissions);
    },
  },
};
</script>

